import type { Toast } from "./useToasts"

export function Toasts({
  toasts,
  onDismiss,
}: {
  toasts: Toast[]
  onDismiss: (id: number) => void
}) {
  if (toasts.length === 0) return null

  return (
    // Announced politely so the readout does not interrupt whatever the
    // player is reading, but is still reachable by screen readers.
    <div className="toast-stack" role="status" aria-live="polite">
      {toasts.map((toast) => (
        <button
          key={toast.id}
          type="button"
          className={`toast toast-${toast.tone}`}
          onClick={() => onDismiss(toast.id)}
          title="Dismiss"
        >
          {toast.text}
        </button>
      ))}
    </div>
  )
}
